import React, { useEffect, useState } from "react";
import { Col, Form } from "react-bootstrap";
import { Simplebar } from "components";
import EditContainer from "components/PantallasEdit/EditContainer/EditContainer";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import { SeguridadManager } from "managers";
import useExceptionHandler from "hooks/useExceptionHandler";
import { DateHelper } from "utils";

export default function LogAuditoriaView({
  showLoading,
  hideLoading,
  IdSec,
  showCanvas,
  setShowCanvas,
}) {
  const [log, setLog] = useState({});
  const [campos, setCampos] = useState([]);
  const { handleException } = useExceptionHandler();

  const formatValue = (value) => {
    if (!value) return value;
    if (/^\d{4}-\d{2}-\d{2}/.test(String(value))) {
      return DateHelper.formatStringDate(value, true);
    }
    return value;
  };

  useEffect(() => {
    if (IdSec && showCanvas) {
      showLoading();
      SeguridadManager.buscarLogAuditoria(IdSec)
        .then((res) => {
          try {
            setLog(res.Data ?? {});
            setCampos(JSON.parse(res.Data?.Campos || "[]"));
          } catch {
            setCampos([]);
          }
        })
        .catch(handleException)
        .finally(hideLoading);
    }
  }, [IdSec, showCanvas]);

  return (
    <Simplebar
      backdrop={"static"}
      placement={"end"}
      size="xxl"
      portal={false}
      visible={showCanvas}
      setShow={(e) => setShowCanvas(e)}
      title={`Log de Auditoría (Id: ${IdSec ?? ""})`}
      btnLeft={{ show: false }}
      btnRight={{ show: false }}
    >
      <Col>
        <Form action="" className="form-horizontal" method="">
          <EditContainer>
            <SectionRow>
              <InputContainer stacked label="Tabla" labelClassName="d-flex">
                <Form.Control type="text" value={log.Tabla ?? ""} readOnly />
              </InputContainer>
              <InputContainer stacked label="Id" labelClassName="d-flex">
                <Form.Control type="text" value={log.Referencia ?? ""} readOnly />
              </InputContainer>
            </SectionRow>
            <SectionRow>
              
            </SectionRow>
            {campos.map((campo, index) => (
              <React.Fragment key={index}>
                <EditSection title={campo.Columna} />
                <SectionRow>
                  <InputContainer stacked label="Valor original" labelClassName="d-flex">
                    <Form.Control type="text" value={formatValue(campo.Original) ?? ""} readOnly />
                  </InputContainer>
                  <InputContainer stacked label="Valor actual" labelClassName="d-flex">
                    <Form.Control type="text" value={formatValue(campo.Actual) ?? ""} readOnly />
                  </InputContainer>
                </SectionRow>
              </React.Fragment>
            ))}
          </EditContainer>
        </Form>
      </Col>
    </Simplebar>
  );
}
